import { render, staticRenderFns } from "./AdvTitleBlock.vue?vue&type=template&id=6f0f53de"
import script from "./AdvTitleBlock.vue?vue&type=script&lang=js"
export * from "./AdvTitleBlock.vue?vue&type=script&lang=js"
import style0 from "./AdvTitleBlock.vue?vue&type=style&index=0&id=6f0f53de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports